import { createFileRoute, useNavigate } from "@tanstack/react-router";

import oldDoctorWithPatient from "@/assets/old-doctor-with-patient.webp";
import { Button } from "@/components/ui/button/button";
import { ImageDrawerLayout } from "@/components/ui/layout/image-drawer/image-drawer-layout";
import { generateLivanceContactUrl } from "@/lib/helpers/contact-url";
import { env } from "@/lib/utils/env";

import type { JSX } from "react";

const SCHEDULE_VISIT_URL = env.VITE_ANIMUS_URL;

const FirstAccessDocumentNotFoundPage = (): JSX.Element => {
  const navigate = useNavigate();

  const handleTalkToTeam = (): void => {
    const url = generateLivanceContactUrl("whatsapp");

    window.open(url, "_blank", "noopener,noreferrer");
  };

  const handleScheduleVisit = (): void => {
    window.open(SCHEDULE_VISIT_URL, "_blank");
  };

  const handleTryAgain = (): void => {
    void navigate({ to: "/auth/first-access/document" });
  };

  return (
    <ImageDrawerLayout>
      <ImageDrawerLayout.Image>
        <img
          src={oldDoctorWithPatient}
          alt="Profissional de saúde recebendo paciente na Livance"
          className="w-full h-full object-cover object-top"
        />
      </ImageDrawerLayout.Image>

      <ImageDrawerLayout.Drawer>
        <div className="flex flex-col gap-2">
          <h1 className="text-2xl font-medium text-neutral-700 leading-[1.32]">
            Ainda não localizamos um cadastro para este CPF
          </h1>
          <div className="text-base text-neutral-600 font-normal leading-[1.32]">
            <p>
              Se você já iniciou um cadastro ou acha que isso é um engano, fale com o
              nosso time.
            </p>
            <p>Se ainda não conhece a Livance, você pode agendar uma visita.</p>
          </div>
        </div>

        <div className="flex flex-col gap-3">
          <Button fullWidth onClick={handleTalkToTeam}>
            Falar com nosso time
          </Button>

          <Button fullWidth color="secondaryLight" onClick={handleScheduleVisit}>
            Agendar visita
          </Button>

          <Button fullWidth color="secondaryLight" onClick={handleTryAgain}>
            Tentar novamente
          </Button>
        </div>
      </ImageDrawerLayout.Drawer>
    </ImageDrawerLayout>
  );
};

export const Route = createFileRoute("/auth/first-access/document-not-found")({
  component: FirstAccessDocumentNotFoundPage,
});
